module.exports = __webpack_public_path__ + "static/media/pic111.8ff99216.png";